<template>
  <div class="sn-f-col-c-c sn-pointer app-float" ref="float" v-if="floatPrinciple && floatPrinciple.length > 0 && exhibition" @mousedown="mousedown()" @mouseup="mouseup()">
    <div class="float">
      <div class="sn-f-col-c-c float-single" :key="i" v-for="(item, i) in floatPrinciple">
        <div class="iconfont" :class="icon(item.split('-')[1])"></div>
        <div class="expand">
          <img :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/qr/' + item.split('-')[0] + '-1-' + $sn.utils.getHospitalId() + '.png'">
        </div>
      </div>
      <div class="sn-f-col-c-c float-single" @click="top();">
        <div class="iconfont icon-xiazai sn-tr-180"></div>
        <div>置顶</div>
      </div>
    </div>
    <div class="iconfont icon-shanchu-mian-" @click="exhibition = false;"></div>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';

export default {
  name: 'app-float',
  data() {
    return {
      ALI_CLOUD_DOMAIN_STATIC: self.$sn.constants.ALI_CLOUD_DOMAIN_STATIC,
      exhibition: true,
      floatPrinciple: self.$sn.getConfig('floatPrinciple')
    };
  },
  computed: {
    icon() {
      return (type) => {
        const digital = {
          '0': 'icon-weixin2',
          '1': 'icon-zhifubao1'
        };
        return digital[type];
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.eventBus.$on('Broadcast_InitialComplete', () => {
        this.floatPrinciple = this.$sn.getConfig('floatPrinciple');
      });
    });
  },
  methods: {
    mousedown(event) {
      event = event || window.event;
      const x = event.clientX - this.$refs.float.offsetLeft;
      const y = event.clientY - this.$refs.float.offsetTop;
      document.onmousemove = (event) => {
        event = event || window.event;
        this.move(event, {
          x,
          y
        });
      };
    },
    move(event, position) {
      let x = event.clientX - position.x;
      let y = event.clientY - position.y;
      if (x < 0) x = 0;
      if (y < 0) y = 0;
      this.$refs.float.style.left = x + 'px';
      this.$refs.float.style.top = y + 'px';
    },
    mouseup() {
      document.onmousemove = null;
      document.onmouseup = null;
    },
    top() {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  },
  beforeDestroy() {
    window.eventBus.$off('Broadcast_InitialComplete');
  }
};
</script>
<style lang="scss" scoped>
.app-float {
  width: 60px;
  position: fixed;
  top: 200px;
  right: 40px;
  z-index: 999;

  .float {
    width: 60px;
    background-color: $main;
    border-radius: 10px;

    .float-single {
      width: 60px;
      height: 60px;
      position: relative;

      &:last-child {
        @include fs(16);

        color: $white;

        .iconfont {
          font-size: 20px;
          margin-top: 5px;
        }
      }

      &:hover {
        .expand {
          display: block;
        }
      }

      .iconfont {
        font-size: 40px;
        color: $white;
      }

      .expand {
        display: none;
        overflow: hidden;
        width: 300px;
        background-color: $main;
        border-radius: 10px;
        padding: 10px;
        position: absolute;
        top: 50%;
        right: 70px;
        transform: translateY(-50%);
        z-index: 999;

        img {
          width: 280px;
          height: auto;
        }
      }
    }
  }

  .icon-shanchu-mian- {
    font-size: 30px;
    color: $main;
    margin-top: 10px;
  }
}
</style>
